import { dataViewI18nT } from '@blocksuite/data-view';
import {
  type DatabaseLimitDetail,
  databaseLimitMessageKey,
} from '@streamlain/database-identity';

/** User-facing text of a database limit; never mentions byte sizes. */
export function databaseLimitNoticeText(detail: DatabaseLimitDetail): string {
  return dataViewI18nT(`database.limit.${databaseLimitMessageKey(detail)}`, {
    limit: new Intl.NumberFormat().format(detail.limit),
  });
}
